import React, { useState, useEffect } from 'react';
import { Layout } from '../components/layout/Layout';
import { useLanguage } from '../context/LanguageContext';
import { ExternalLink, Building2, GraduationCap, Landmark, Truck, Factory, MapPin } from 'lucide-react';

const PartnersPage = () => {
  const { t, language } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState('all');

  // Updated partners list with real data
  const partners = [
    // Russian Universities
    {
      id: '1',
      name_fr: 'Université RUDN (Université de l\'Amitié des Peuples)',
      name_en: 'RUDN University (Peoples\' Friendship University)',
      name_ru: 'РУДН (Российский университет дружбы народов)',
      description_fr: 'Université internationale de premier plan, accueillant des milliers d\'étudiants africains depuis des décennies. Partenaire académique stratégique de l\'OAR.',
      description_en: 'Leading international university, welcoming thousands of African students for decades. Strategic academic partner of OAR.',
      description_ru: 'Ведущий международный университет, принимающий тысячи африканских студентов на протяжении десятилетий. Стратегический академический партнёр ОАР.',
      category: 'universite_russe',
      country: 'Russie',
      website_url: 'https://www.rudn.ru',
      icon: GraduationCap,
    },
    {
      id: '2',
      name_fr: 'Ministère Russe de l\'Éducation',
      name_en: 'Russian Ministry of Education',
      name_ru: 'Министерство образования России',
      description_fr: 'Partenaire institutionnel pour la coordination des programmes de bourses et la reconnaissance des diplômes.',
      description_en: 'Institutional partner for coordinating scholarship programs and diploma recognition.',
      description_ru: 'Институциональный партнёр по координации стипендиальных программ и признанию дипломов.',
      category: 'institution_russe',
      country: 'Russie',
      website_url: 'https://edu.gov.ru',
      icon: Landmark,
    },
    // Russian Language Centers in Africa
    {
      id: '3',
      name_fr: 'Centre Linguistique Russe du Cameroun',
      name_en: 'Russian Language Center of Cameroon',
      name_ru: 'Русский языковой центр Камеруна',
      description_fr: 'Centre de formation linguistique et culturel pour la promotion du russe au Cameroun.',
      description_en: 'Linguistic and cultural training center for promoting Russian in Cameroon.',
      description_ru: 'Центр языковой и культурной подготовки для продвижения русского языка в Камеруне.',
      category: 'centre_linguistique',
      country: 'Cameroun',
      website_url: '#',
      icon: GraduationCap,
    },
    {
      id: '4',
      name_fr: 'Centre Linguistique Russe du Niger',
      name_en: 'Russian Language Center of Niger',
      name_ru: 'Русский языковой центр Нигера',
      description_fr: 'Centre de formation linguistique et culturel pour la promotion du russe au Niger.',
      description_en: 'Linguistic and cultural training center for promoting Russian in Niger.',
      description_ru: 'Центр языковой и культурной подготовки для продвижения русского языка в Нигере.',
      category: 'centre_linguistique',
      country: 'Niger',
      website_url: '#',
      icon: GraduationCap,
    },
    {
      id: '5',
      name_fr: 'Centre Linguistique Russe de la République Centrafricaine',
      name_en: 'Russian Language Center of Central African Republic',
      name_ru: 'Русский языковой центр Центральноафриканской Республики',
      description_fr: 'Centre de formation linguistique et culturel pour la promotion du russe en Centrafrique.',
      description_en: 'Linguistic and cultural training center for promoting Russian in Central African Republic.',
      description_ru: 'Центр языковой и культурной подготовки для продвижения русского языка в ЦАР.',
      category: 'centre_linguistique',
      country: 'Centrafrique',
      website_url: '#',
      icon: GraduationCap,
    },
    // Economic Partners
    {
      id: '6',
      name_fr: 'ADGAZ LLC (Adagaz-R LLC)',
      name_en: 'ADGAZ LLC (Adagaz-R LLC)',
      name_ru: 'ООО АДАГАЗ-Р',
      description_fr: 'Société moscovite (fondée en 2020) spécialisée dans l\'exportation de produits agricoles (huile de tournesol, céréales), d\'engrais et de pétrole depuis la Russie vers le Moyen-Orient et l\'Afrique. Membre de l\'AFROCOM.',
      description_en: 'Moscow-based company (founded in 2020) specializing in exporting agricultural products (sunflower oil, cereals), fertilizers and petroleum from Russia to the Middle East and Africa. Member of AFROCOM.',
      description_ru: 'Московская компания (основана в 2020 году), специализирующаяся на экспорте сельскохозяйственной продукции (подсолнечное масло, зерновые), удобрений и нефти из России на Ближний Восток и в Африку. Член АФРОКОМ.',
      category: 'entreprise',
      country: 'Russie',
      website_url: '#',
      icon: Factory,
    },
    {
      id: '7',
      name_fr: 'KAMAZ',
      name_en: 'KAMAZ',
      name_ru: 'КАМАЗ',
      description_fr: 'Le premier et le plus grand fabricant de camions en Russie. Partenaire industriel stratégique pour le développement des infrastructures en Afrique.',
      description_en: 'The first and largest truck manufacturer in Russia. Strategic industrial partner for infrastructure development in Africa.',
      description_ru: 'Первый и крупнейший производитель грузовых автомобилей в России. Стратегический промышленный партнёр по развитию инфраструктуры в Африке.',
      category: 'entreprise',
      country: 'Russie',
      website_url: 'https://kamaz.ru',
      icon: Truck,
    },
    {
      id: '8',
      name_fr: 'Association des Importateurs et Exportateurs des Produits Pharmaceutiques',
      name_en: 'Association of Pharmaceutical Products Importers and Exporters',
      name_ru: 'Ассоциация импортёров и экспортёров фармацевтической продукции',
      description_fr: 'Association professionnelle facilitant les échanges de produits pharmaceutiques entre la Russie et l\'Afrique.',
      description_en: 'Professional association facilitating pharmaceutical products exchanges between Russia and Africa.',
      description_ru: 'Профессиональная ассоциация, способствующая обмену фармацевтической продукцией между Россией и Африкой.',
      category: 'entreprise',
      country: 'Russie',
      website_url: '#',
      icon: Building2,
    },
  ];

  // Upcoming centers
  const upcomingCenters = [
    { country: 'Éthiopie', flag: '🇪🇹' },
    { country: 'Cameroun', flag: '🇨🇲' },
    { country: 'Ghana', flag: '🇬🇭' },
    { country: 'Centrafrique', flag: '🇨🇫' },
    { country: 'Mali', flag: '🇲🇱' },
    { country: 'Niger', flag: '🇳🇪' },
    { country: 'Burkina Faso', flag: '🇧🇫' },
  ];

  const categories = [
    { key: 'all', label: t('partners.categories.all') },
    { key: 'universite_russe', label: t('partners.categories.universite_russe') },
    { key: 'institution_russe', label: 'Institutions Russes' },
    { key: 'centre_linguistique', label: 'Centres Linguistiques' },
    { key: 'entreprise', label: 'Partenaires Économiques' },
  ];

  const filteredPartners = selectedCategory === 'all'
    ? partners
    : partners.filter(p => p.category === selectedCategory);

  const getName = (partner) => {
    return partner[`name_${language}`] || partner.name_fr;
  };

  const getDescription = (partner) => {
    return partner[`description_${language}`] || partner.description_fr;
  };

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative py-32 md:py-40 bg-oar-blue-dark">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <span className="text-xs md:text-sm uppercase tracking-[0.2em] text-oar-orange font-bold">
            Réseau International
          </span>
          <h1
            data-testid="partners-title"
            className="font-heading text-4xl md:text-6xl font-bold tracking-tight text-white mt-4 mb-6"
          >
            {t('partners.title')}
          </h1>
          <p className="max-w-2xl text-lg text-gray-300">
            {t('partners.subtitle')}
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-8 bg-oar-bg-secondary border-b border-oar-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-4">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => setSelectedCategory(cat.key)}
                data-testid={`filter-${cat.key}`}
                className={`px-4 py-2 text-sm rounded-sm transition-all duration-300 ${
                  selectedCategory === cat.key
                    ? 'bg-oar-blue text-white font-medium'
                    : 'text-oar-text-secondary hover:text-oar-blue border border-oar-border hover:border-oar-blue/50'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="py-16 bg-oar-bg-primary">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredPartners.map((partner) => {
              const IconComponent = partner.icon || Building2;
              return (
                <div
                  key={partner.id}
                  data-testid={`partner-${partner.id}`}
                  className="bg-white border border-oar-border rounded-sm p-6 card-hover shadow-sm"
                >
                  {/* Icon */}
                  <div className="w-12 h-12 flex items-center justify-center bg-oar-blue-soft rounded-sm mb-4">
                    <IconComponent className="w-6 h-6 text-oar-blue" />
                  </div>

                  {/* Content */}
                  <h3 className="font-heading text-lg text-oar-text-primary mb-2">
                    {getName(partner)}
                  </h3>
                  <p className="text-oar-orange text-xs uppercase tracking-wider mb-3 flex items-center gap-1">
                    <MapPin className="w-3 h-3" />
                    {partner.country}
                  </p>
                  <p className="text-oar-text-secondary text-sm leading-relaxed mb-4">
                    {getDescription(partner)}
                  </p>

                  {/* Link */}
                  {partner.website_url && partner.website_url !== '#' && (
                    <a
                      href={partner.website_url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 text-oar-blue text-sm hover:text-oar-blue-light transition-colors"
                    >
                      {t('partners.visitWebsite')}
                      <ExternalLink className="w-3 h-3" />
                    </a>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Upcoming Centers Section */}
      <section className="py-16 bg-oar-bg-secondary">
        <div className="tricolor-line" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-12">
          <h2 className="font-heading text-2xl md:text-3xl text-oar-text-primary text-center mb-8">
            {language === 'fr' ? 'Centres à venir' : language === 'en' ? 'Upcoming Centers' : 'Предстоящие центры'}
          </h2>
          <p className="text-oar-text-secondary text-center mb-8 max-w-2xl mx-auto">
            {language === 'fr' 
              ? 'L\'OAR développe son réseau de centres linguistiques et de coopération dans les pays suivants :'
              : language === 'en'
              ? 'OAR is developing its network of language and cooperation centers in the following countries:'
              : 'ОАР развивает сеть языковых центров и центров сотрудничества в следующих странах:'
            }
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {upcomingCenters.map((center, index) => (
              <div
                key={index}
                className="flex items-center gap-2 bg-white border border-oar-border px-6 py-3 rounded-lg shadow-sm"
              >
                <span className="text-2xl">{center.flag}</span>
                <span className="text-oar-text-primary font-medium">{center.country}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-oar-blue-dark">
        <div className="africa-line" />
        <div className="max-w-7xl mx-auto px-6 md:px-12 pt-12">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-orange">50+</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-2">Universités</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-orange">25+</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-2">Institutions</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-orange">15+</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-2">Pays</div>
            </div>
            <div>
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-orange">10+</div>
              <div className="text-sm text-gray-400 uppercase tracking-wider mt-2">Entreprises</div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PartnersPage;
